import React, { useState } from 'react'
import { initializeApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { getFirebaseConfig } from '../lib'

import './payment.css'
import SignaturePad from 'react-signature-pad-wrapper'
import ReCAPTCHA from "react-google-recaptcha"
import html2canvas from 'html2canvas'
import { PayrocHostedFieldsWrapper } from "../@/app/api/lib/payrocHostedFields.ts"

//synch d-buy
import SynchDbuy from './synchdbuy2.js'

// import banner from '../images/banner.png'

import Receipt from './receipt.js'

const recaptchaRef = React.createRef()

const app = initializeApp(getFirebaseConfig())

// const analytics = getAnalytics(app) // eslint-disable-line no-unused-vars
export default class Payment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paymentMethodsAch: {
        creditCard: {
          enabled: false
        },
        ach: {
          enabled: true
        }
      },
      paymentMethodsCC: {
        creditCard: {
          enabled: true
        },
        ach: {
          enabled: false
        }
      },
      fields: {
        ccnumber: {
          valid: false
        },
        ccexp: {
          valid: false
        },
        cvv: {
          valid: false
        },
        checkaba: {
          valid: false
        },
        checkaccount: {
          valid: false
        },
        checkname: {
          valid: false
        }
      },
      firstName: '',
      lastName: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      amount: undefined,
      capture_signature: undefined,
      sigPadKey: Date.now(),
      isSubmitting: false,
      notInvalid: false,
      submitDisabled: true,
      alertMessage: '',
      merchantId: undefined,
      orderId: undefined,
      accountName: '',
      accountPhone: '',
      accountEmail: '',
      accountStreet: '',
      accountCity: '',
      accountState: '',
      accountZip: '',
      accountImage: '',
      receipt: false,
      complete: false,
      lendResult: '',
      lendResultLoading: true,
      isSynchrony: false,
      lendApplyUrl: '',
      signatureHidden: true,
      showCaptchaSignature: false,
      Venmo: '',
      hasApplePay: false,
      hasGooglePay: false,
      hasVenmo: false,
      hasPayPal: false,
      payPalMerchantStatus: '',
      hasCFP: false,
      hasFleet: false,
      fleetToken: '',
      Hide_Paypal_Pay_Later: false,
      disclosure: '',
      disableCC: false,
      worldnetUrl: undefined,
      isInternal: false,
      isExpired: false,
      isComplete: false,
      isCanceled: false,
      invalid: false,
      invalidMessage: '',
      payWithACH: false,
      invoiceNotes: '',
      hexColorCode: '',
      makeModel : '',
      canClosePage: false,
      invoiceNotesLabel: '',
      hideSignature: false,
      showOrderId: false,
      hideHeader: false,
      hideAuxillaryPayments: false,
      dBuyStarted: false,
      dBuyNeedsFinal: false,
      dBuyClosed: false,
      synchronyPromoCode: '', 
      synchronyPromoDescr: '',
      synchkey: 1,
      reloadSynchrony: false,
      payWithVoyager: false,
      payWithWex: false,
      fleetitems: [],
      fleettotal: 0,
      fleetediting: false,
      payrocFields: false,
    }
    this.setState = this.setState.bind(this)
    this.handleShowCC = this.handleShowCC.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.finishSubmit = this.finishSubmit.bind(this)
    this.loadCollect = this.loadCollect.bind(this)
    this.loadACHCollect = this.loadACHCollect.bind(this)
    this.handleEmail = this.handleEmail.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onZipChange = this.onZipChange.bind(this)
    this.onAddressChange = this.onAddressChange.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.toggleSignature = this.toggleSignature.bind(this)
    this.toggleACH = this.toggleACH.bind(this)

    this.handleGetSignature = this.handleGetSignature.bind(this)
    this.fieldValidation = this.fieldValidation.bind(this)
    this.submitError = this.submitError.bind(this)
    this.updateSubmitDisabled = this.updateSubmitDisabled.bind(this)
    this.fieldsAvailable = this.fieldsAvailable.bind(this)
    this.handleCancelAlert = this.handleCancelAlert.bind(this)
    this.handleWex = this.handleWex.bind(this)
    this.handleVoyager = this.handleVoyager.bind(this)
    this.setIsEditing = this.setIsEditing.bind(this)
    this.handleSaveFleetItems = this.handleSaveFleetItems.bind(this)
    // this.loadLendResults = this.loadLendResults.bind(this)
    this.signaturePadRef = React.createRef()
    //this.getImage('Venmo')
  }

  /*getImage (image) {
    storage.child(`${image}.png`).getDownloadURL().then((url) => {
      this.state[image] = url
      this.setState(this.state)
    })
  }
  */
  async componentDidMount() {
    const functions = getFunctions(app)
    const signedPayment = httpsCallable(functions, 'onCall-signedPayment')
    try {
      const urlSearchParams = new URLSearchParams(window.location.search)
      const {
        id,
      } = Object.fromEntries(urlSearchParams.entries())
      
      console.log('calling signedPayment')
      const result = await signedPayment({ id })
      const { accountImage, ...noImg } = result.data
      console.log(JSON.stringify(noImg))
      const {
        accountName,
        accountPhone,
        accountEmail,
        accountStreet,
        accountCity,
        accountState,
        accountZip,
        firstName,
        lastName,
        phone,
        address,
        city,
        state,
        zip,
        orderId,
        merchantId,
        terminalId,
        amount,
        datetime,
        expire,
        refId,
        signature,
        cfpPartnerKey,
        termsAndConditions,
        invoiceUrl,
        invoiceRef,
        payPalId,
        payPalMerchantStatus = '',
        payPalPlatformFee,
        disclosure = '',
        payPalService = '',
        hasApplePay = false,
        hasGooglePay = false,
        hasVenmo = false,
        hasFleet = false,
        fleetToken = '',
        hasPayPal = false,
        hasCFP = false,
        disableCC = false,
        hasCreditCard = false,
        velox_token_key,
        worldnetUrl,
        isInternal = false,
        hideHeader = false,
        achEnabled = false,
        authOnly = false,
        hideAuxillaryPayments = false,
        invoiceNotes,
        hexColorCode = '#36454F', //'#36454F' Blue Gray
        makeModel = 'Mazda 6',
        canClosePage,
        invoiceNotesLabel = 'Notes',
        hideSignature,
        showOrderId,
        Hide_Paypal_Pay_Later = false,
        payrocToken,
        payrocSrc,
        payrocIntegrity,
      } = result.data
      this.setState({
        merchantId,
        terminalId,
        amount,
        datetime, 
        expire, 
        refId,
        signature,
        accountName,
        accountPhone,
        accountEmail,
        accountStreet,
        accountCity,
        accountState,
        accountZip,
        accountImage,
        firstName,
        lastName,
        phone,
        address,
        city,
        state,
        zip,
        orderId,
        cfpPartnerKey,
        termsAndConditions,
        invoiceUrl,
        invoiceRef,
        payPalId,
        payPalMerchantStatus,
        payPalPlatformFee,
        disclosure,
        payPalService,
        hasApplePay,
        hasGooglePay,
        hasVenmo,
        hasFleet,
        fleetToken,
        hasPayPal,
        hasCFP,
        Hide_Paypal_Pay_Later,
        disableCC,
        hasCreditCard,
        worldnetUrl,
        palPalComplete:false,
        paymentSource:'',
        payer_email:'',
        isInternal,
        hideAuxillaryPayments,
        hideHeader,
        achEnabled,
        payWithACH:false,
        velox_token_key:velox_token_key,
        authOnly,
        invoiceNotes,
        hexColorCode,
        makeModel,
        canClosePage,
        invoiceNotesLabel,
        hideSignature,
        showOrderId,
        fleetProcessing: false,
        payrocFields: !!payrocToken,
        payrocToken,
        payrocSrc,
        payrocIntegrity,
      })
      if(!hexColorCode) this.setState({ hexColorCode: '#36454F' })
      if(isInternal) this.setState({ hideAuxillaryPayments: true })
      // console.log('result.data', JSON.stringify(result.data))
      // console.log('componentDidMount achEnabled', achEnabled)
      // console.log('hasPayPal', this.state.hasPayPal)
      // console.log('authOnly', this.state.authOnly)
      // console.log('hasVenmo', this.state.hasVenmo)
      // console.log('payWithACH', this.state.payWithACH)
      // console.log('payPalService', this.state.payPalService)
      // console.log('payPalMerchantStatus', this.state.payPalMerchantStatus)
      // console.log('payment hasCFP', this.state.hasCFP)
      // console.log('Hide_Paypal_Pay_Later', this.state.Hide_Paypal_Pay_Later)
      // console.log('hideAuxillaryPayments', this.state.hideAuxillaryPayments)
      // console.log('hasApplePay', this.state.hasApplePay)
      if (payrocToken && payrocSrc && payrocIntegrity) {
        const script = document.createElement("script")
        script.src = payrocSrc
        script.integrity = payrocIntegrity
        script.crossOrigin = "anonymous"

        if (script.readyState) {  // only required for IE <9
          script.onreadystatechange = () => {
            if ( script.readyState === "loaded" || script.readyState === "complete" ) {
              script.onreadystatechange = null
              console.log('reloading collect')
              this.loadPayrocFields()
            }
          }
        } else {  //Others
          script.onload = () => {
            console.log('reloading collect')
            this.loadPayrocFields()
          }
        }
        document.body.appendChild(script)
        this.setState({ showCaptchaSignature: !this.state.isInternal })
      }
      if (velox_token_key) {
        // console.log('Key ', velox_token_key)
        const script = document.createElement("script")
        script.src = "https://velox.transactiongateway.com/token/Collect.js"
        script.async = false
        script.setAttribute('data-tokenization-key', velox_token_key)
        script.setAttribute('data-country', 'US')
        script.setAttribute('data-currency', 'USD')
        script.setAttribute('data-price', amount)
        
        if (script.readyState) {  // only required for IE <9
          script.onreadystatechange = () => {
            if ( script.readyState === "loaded" || script.readyState === "complete" ) {
              script.onreadystatechange = null
              console.log('reloading collect')
              this.loadCollect()
            }
          }
        } else {  //Others
          script.onload = () => {
            console.log('reloading collect')
            this.loadCollect()
          }
        }
        document.body.appendChild(script)
      }
      if (hasCFP && !this.state.hideAuxillaryPayments) {
        this.loadLendResults({ merchantId, cfpPartnerKey, phone, amount })
      } else this.setState({ lendResultLoading: false })

      if(this.state.hideAuxillaryPayments || !(hasApplePay || hasGooglePay || hasCFP || ((hasPayPal || hasVenmo) && payPalMerchantStatus && payPalMerchantStatus==='MERCHANT_ACTIVATED' && !authOnly))) this.setState({ showCC: true, showCaptchaSignature: !this.state.isInternal })
      this.setState({ hoverColor : this.darkenColor(hexColorCode, 15) }) // Darken by 15 units

     
    } catch (err) {
      console.log('error: ', err.message)
      const { code, details: { message = '' } = {} } = JSON.parse(JSON.stringify(err))
      console.log('err: ', code, message)
      if (err.message === 'validation') {
        this.setState({ isSubmitting: false, invalid: true, invalidMessage: message })
      }
      this.setState({ isSubmitting: false, notInvalid: true })
    }
  }

  fleetSuccess = (vaultId) => {
    console.log('Fleet Success '+ vaultId)
    // this.setState({ isSubmitting: false, alertMessage: `VaultId: ${vaultId}`, alertClass: 'alert alert-danger alert-fixed' })
    this.setState({ fleetProcessing: true })
    this.makeFleetPayment(vaultId)
  }

  async makeFleetPayment(vaultId) {
    // fleet API to make payment
    const functions = getFunctions(app)
    const makeFleetPayment = httpsCallable(functions, 'onCall-makeFleetPayment')
    const result = await makeFleetPayment({ 
      fleetitems: this.state.fleetitems,
      vaultId, 
      amount: this.state.amount,
      refId: this.state.refId,
      merchantId: this.state.merchantId,
      terminalId: this.state.terminalId,
      firstName: this.state.firstName,
      lastName: this.state.lastName, 
      orderId: this.state.orderId,
      gateway: this.state.payWithVoyager ? 'Voyager' : 'WEX',
    })
    console.log('result', JSON.stringify(result.data))
    this.setState({ last4: result.data.last4 })
    this.setState({ fleetProcessing: false })
    this.setState({ cardType: this.state.payWithVoyager ? 'Voyager' : 'WEX' })
    this.setState({ authCode:  result.data ? result.data.authResponse : '' })
    this.setState({ amountPaid: result.data ? result.data.amountApproved || this.state.amount : '' })
    this.setState({ paymentDate: result.data && result.data.paymentDate ? result.data.paymentDate : '' })
    this.setState({ avsResponse: result.data && result.data.accountResponseData && result.data.accountResponseData.avs ? result.data.accountResponseData.avs : '' })
    // this.setState({ paymentType: gateway })
    // console.log('makeFleetPayment: ', JSON.stringify(result))
    if (result && result.data && result.data.error) {
      this.setState({ alertMessage: 'Unable to make fleet payment ' + result.data.error, alertClass: 'alert alert-danger alert-fixed' })
      this.setState({ payWithWex : false })
      this.setState({ payWithVoyager : false })
      this.setState({ showCC : true })
    } else {
      this.setState({ 
        isComplete: true,
        alertMessage: null, 
        alertClass: null, 
        completeMessage: 'Approved',
        isSubmitting: false,
        receipt: true,
      })
      //do something on success
    }
    
  }

  fleetError = (data) => {
    console.log('Fleet Error '+ data)
    this.setState({ isSubmitting: false, alertMessage: `${data}`, alertClass: 'alert alert-danger alert-fixed' })
  }

  fleetInvalid = (data) => {
    console.log('Fleet Invalid '+ data)
    this.setState({ isSubmitting: false, alertMessage: `${data}`, alertClass: 'alert alert-danger alert-fixed' })
  }

  async loadLendResults({ merchantId, cfpPartnerKey, phone, amount }) {
    const {
      refId,
    } = this.state
    try {
      console.log('phone', phone)
      phone = phone.replaceAll('-','').replaceAll('(','').replaceAll(')','').replaceAll(' ','')
      console.log('phone after', phone)
      if (phone.length === 10) {
        this.setState({ lendResultLoading: true })
        this.setState({ isSynchrony: false })
        const functions = getFunctions(app)
        const loadLendResults = httpsCallable(functions, 'onCall-loadLendResults')
        const result = await loadLendResults({ merchantId, cfpPartnerKey, phone, amount, refId })
        console.log('loadLendResults: ', JSON.stringify(result))
        const { 
          lendResult,
          lendApplyUrl,
        } = result.data
        console.log('loadLendResults: ', lendResult, ' ', lendApplyUrl)
        // if (!lendResult || lendResult=='No Financing Options Found' || lendResult=='No Payment Plans Available') this.setState({ hasCFP: false })
        this.setState({ lendResult, lendApplyUrl })
        if (lendResult && (lendResult.includes('Synchrony') || lendResult.includes('Car Care')) ) {
          console.log('isSynchrony: true', lendResult.includes('Synchrony'),lendResult.includes('Car Care') )
          this.setState({ isSynchrony: true })
        }
        this.setState({ lendResultLoading: false })
        
      } else {
        this.setState({ lendResult: '', lendApplyUrl: '' })
        this.setState({ lendResultLoading: false })
      }
    } catch (err) {
      console.log('error: ', err.message)
      this.setState({ isSubmitting: false, notInvalid: true })
      this.setState({ lendResultLoading: false })
    }
  }

  async validateCustomerDetails () {
    console.log('presubmit!!')
    // Implement any additional validation logic here if needed
    // const {
    //   // payrocSignature = false,
    //   isInternal
    // } = this.state
    // if (!isInternal && !payrocSignature) {
    //   this.setState({ payrocSignature: true, hideSignature: false, showCaptchaSignature: true })
    //   return false
    // }
    const {
      payrocFieldIsValid = {},
      payrocForm,
      firstName,
      lastName,
    } = this.state

    if (!firstName) {
      this.submitError(`Billing First Name is required`)
      return false
    }
    if (!lastName) {
      this.submitError(`Billing Last Name is required`)
      return false
    }

    let res = await payrocForm.submitCardholderFirstLastName(firstName, lastName)
    console.log('name: ', JSON.stringify(res))
    console.log('payroc: ', JSON.stringify(payrocFieldIsValid))
    if (
      // (!Object.hasOwn(payrocFieldIsValid, 'cardholderName') || !payrocFieldIsValid.cardholderName) ||
      (!Object.hasOwn(payrocFieldIsValid, 'cardNumber') || !payrocFieldIsValid.cardNumber) ||
      (!Object.hasOwn(payrocFieldIsValid, 'expiryDate') || !payrocFieldIsValid.expiryDate) ||
      (!Object.hasOwn(payrocFieldIsValid, 'cvv') || !payrocFieldIsValid.cvv)
    ) {
      console.log("Payroc Fields not valid")
      return false
    }
    console.log("Validating customer details before submission...")
    // event.preventDefault()
    this.setState({ alertMessage: null })
    const hasSignature = this.signaturePadRef.current && !this.signaturePadRef.current.isEmpty()
    if (hasSignature) {
      const data = this.signaturePadRef.current.toDataURL()
      this.toggleSignature()
      this.setState({ capture_signature: data })
    }
    const hasRecaptcha = !!this.state.recaptcha 
    console.log('hasSignature: ' + hasSignature)
    console.log('hasRecaptcha: ' + hasRecaptcha)
    const {
      address,
      city,
      state,
      zip
    } = this.state
    
    if (!address) {
      this.submitError(`Billing Street Address is required`)
      return false
    }
    if (!city) {
      this.submitError(`Billing City is required`)
      return false
    }
    if (!state) {
      this.submitError(`Billing State/Province is required`)
      return false
    }
    if (!zip) {
      this.submitError(`Billing Zip/Postal Code is required`)
      return false
    }
    if (this.state.isInternal) {
      this.setState({ isSubmitting: true })
      console.log('starting payment request')
      return true
    } else {
      if (!hasSignature && !this.state.hideSignature) {
        this.submitError(`Signature is required`)
        return false
      } else if (!hasRecaptcha) {
        this.submitError(`Recaptcha is required`)
        return false
      } else {
        this.setState({ isSubmitting: true })
        console.log('starting payment request')
        return true 
      }
    }
    
  }

  async handlePayrocToken({ token, expiresAt }) {
    console.log('Token: ', token, ' , ExpiresAt: ', expiresAt)
    const functions = getFunctions(app)
    const makePayrocPayment = httpsCallable(functions, 'onCall-makePayrocPayment')

    const {
      merchantId,
      terminalId,
      datetime,
      expire,
      refId,
      signature,
      amount,
      address,
      city,
      state,
      zip,
      orderId,
      recaptcha,
      capture_signature,
      phone,
      email,
      percentage,
      surcharge,
    } = this.state
    try {
      const result = await makePayrocPayment({ percentage, surcharge, recaptcha, capture_signature, merchantId, terminalId, datetime, expire, refId, signature, amount, address, city, state, zip, token, orderId, phone })
      const {
        status,
        authCode,
        amountPaid,
        process,
        paymentType,
        last4,
        cardType,
        avsResponse,
        isInternal,
        isFinal,
        finalMsg, 
        paymentDate,
        responsetext,
        payrocToken,
        firstName,
        lastName,
      } = result.data
      console.log('result.data: ', JSON.stringify(result.data))
      
      if (payrocToken) {
        this.setState({ payrocToken })
      }

      if (isInternal) {
        if (status ===  'Success') {
          this.setState({ 
            isComplete: true,
            alertMessage: null, 
            alertClass: null, 
            completeMessage: 'Approved',
            isSubmitting: false,
            receipt: false,
          })
        } else {
          //relaod collectjs and recaptcha
          this.handleClear()
          // this.reloadCollectJS(false)
          this.loadPayrocFields()
          if (isFinal) this.setState({ invalid: true, invalidMessage: status + '.  ' + finalMsg })
          this.setState({ submitDisabled: true, isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
          console.log('reloaded collectjs ')
        }
        window.top.postMessage(JSON.stringify({
          error: (status !==  'Success') ? true : false,
          message: {
            refId,
            status,
            orderId,
            firstName,
            lastName,
            address,
            city,
            state,
            zip,
            phone,
            email,
            authCode,
            amountPaid,
            process,
            paymentType,
            last4,
            cardType,
            avsResponse,
            paymentDate,
          }
        }),
          '*'
        )
      } else {
        if (status ===  'Success') {
          this.setState({ 
            isSubmitting: false, 
            authCode, 
            alertMessage: null, 
            amountPaid, 
            process,
            paymentType,
            last4,
            cardType,
            avsResponse,
            receipt: true, 
            alertClass: null,
            paymentDate,
            firstName,
            lastName,
          })
        } else {
          //reload collectjs for Max Amount, CVV and AVS errors 
          // Max Amount errors should be caught durimg paymentUdl API call, but in case existing links are already there, lets catch them here, and handle properly
          
          if ((status && status.startsWith('Could not process. Address')) || status==='CVV is not valid' || responsetext==='Amount exceeds the maximum ticket allowed') {
              this.handleClear()
              this.loadPayrocFields()
              if (isFinal) this.setState({ invalid: true, invalidMessage: status + '.  ' + finalMsg })
              this.setState({ submitDisabled: true, isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
          } else {
            //relaod collectjs and recaptcha
            this.handleClear()
            // this.reloadCollectJS(false)
            this.loadPayrocFields()
            if (isFinal) this.setState({ invalid: true, invalidMessage: status + '.  ' + finalMsg })
            this.setState({ submitDisabled: true, isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
            console.log('reloaded collectjs ')
          }
        }
      }
      // window.location.reload(false)
    } catch(err) {
      console.log('error: ', err.message)
      window.top.postMessage(JSON.stringify({
        error: true,
        message: {
          status: err.message,
        }
      }),
        '*'
      )
      const { code, details: { message = '' } = {} } = JSON.parse(JSON.stringify(err))
      console.log('err: ', code, message)
      if (err.message === 'ECONNRESET') {
        this.setState({ isSubmitting: false, invalid: true, invalidMessage: message })
      } else {
        this.setState({ isSubmitting: false, invalid: true, invalidMessage: err.message })
      }
    }
  }

  async loadPayrocFields() {
    console.log('loadPayrocFields')
    const {
      payrocForm
    } = this.state
    // this is a reload, need a new payrocToken ...
    if (payrocForm) {
      document.querySelectorAll('iframe').forEach(iframe => {
        const parent = iframe.parentElement
        // Only remove if direct parent has this class
        if (( parent?.classList.contains('card-number') || parent?.classList.contains('card-holder-name') || 
          parent?.classList.contains('card-cvv') || parent?.classList.contains('card-expiry') || parent?.classList.contains('submit-button'))) {
          iframe.remove()
        }
      })
      payrocForm.destroy()
    }
    
    const cardForm = new PayrocHostedFieldsWrapper({
      sessionToken: this.state.payrocToken, // payroc session token
      testWorldnet: this.state.testWorldnet, // payroc session token
      paymentType: "card",
      onPreSubmit: () => this.validateCustomerDetails(),
      fieldsConfig: {
        cardholderName: {
          target: ".card-holder-name",
          errorTarget: ".card-holder-name-error",
          placeholder: "Name",
        },
        cardNumber: {
          target: ".card-number",
          errorTarget: ".card-number-error",
          placeholder: "Card Number",
        },
        cvv: {
          wrapperTarget: ".card-cvv-wrapper",
          target: ".card-cvv",
          errorTarget: ".card-cvv-error",
          placeholder: "CVV",
          selector: '#ccexp',
        },
        expiryDate: {
          wrapperTarget: ".card-expiry-wrapper",
          target: ".card-expiry",
          errorTarget: ".card-expiry-error",
          placeholder: "Expiration Date (MM/YY)",
        },
        submit: {
          target: ".submit-button",
          value: "Pay Now",
        },
      },
      cardholderFirstName: "bob",
      cardholderLastName: "smith",
      styles: {
        // disableDefaultStyles: true,
        css: {
          input: {
            "display": "block",
            "width": "100%",
            "padding": "0.375rem 0.75rem",
            "font-size": '1rem',
            "font-weight":'400',
            "line-height": "24px",
            "height": "38px",
            "color": "#212529",
            "background-color": "#fff",
            // "background-clip": "padding-box",
            "border": "1px solid #ced4da",
            // "-webkit-appearance": "none",
            "appearance": "none",
            "border-radius": "0.25rem",
            "transition": "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
            // "text-transform": "none"
          },
          button: {
            "background-color": "rgb(23, 134, 97)",
            color: "#FFF",
            border: "1px rgb(23, 134, 97) solid",
            "border-radius": "8px",
            width: "100%",
            "text-align": "center",
            "min-height": "45px",
            padding: "8px",
          },
          div: {
            margin: "0",
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            "margin-left": "8px",
          },
          "button:hover": {
            cursor: "pointer",
          },
          "::before": {
            width: "-webkit-fill-available"
          },
          iframe: {
            width: "100% !important",
          }
        },
      }
    })
    const payrocFormWrapper = await cardForm.init()
    
    payrocFormWrapper.on("error", ({ type, field, message }) => {
      console.error(`Error ${type} in ${field}: ${message}`)
      if (message === 'The provided session token is invalid.') {
        this.submitError(`Session has expired, please refresh the page.`)
      }
    })

    payrocFormWrapper.on("fieldValidityChange", ({ field, validationError }) => {
      console.log(`field ${field}, erorr: ${validationError}`)
      // need to track for our presubmit check?
      const {
        payrocFieldIsValid = {}
      } = this.state
      payrocFieldIsValid[field] = validationError ? false : true
      this.setState({ payrocFieldIsValid })
    })

    payrocFormWrapper.on("surchargingAllowed", ({ percentage, disclosure })  => {
      console.log(`Surcharging allowed: ${percentage}% - Disclosure: ${disclosure}`)
      var surcharge = document.getElementById('surcharge-disclosure')
      surcharge.innerHTML = `<div>${disclosure}</div><div>Additional charge of USD $${additionalFee(percentage)}</div>`
      Object.assign(surcharge.style, {
        'border-radius': '12px',
        color: 'black',
        fontSize: '1rem',
        border: '2px solid red',
        padding: '10px',
      })
      this.setState({ percentage: percentage, surcharge: true })
    })

    payrocFormWrapper.on("surchargingNotAllowed", ()  => {
      console.log(`Surcharging not allowed`)
      var surcharge = document.getElementById('surcharge-disclosure')
      surcharge.innerHTML = ''
      surcharge.style = ''
      this.setState({ percentage: 0, surcharge: false })
    })

    const truncate = (number, places) => {
      const multiplier = Math.pow(10, places)
      return Math.trunc(number * multiplier) / multiplier
    }

    const additionalFee = (percentage) => {
      console.log(`Additional fee applied: ${percentage}%`)
      const amount = this.state.amount
      const feeAmount = (percentage / 100) * amount 
      return truncate(feeAmount, 2)
    }

    payrocFormWrapper.on("submissionSuccess", ({ token, expiresAt }) => {
      this.handlePayrocToken({ token, expiresAt })
    })
    // cardFormWrapper.form.on("onPreSubmit", () => {
    //   console.log('presubmit!!')
    //   this.validateCustomerDetails()
    // })
    this.setState({ payrocForm: cardForm })
  }

  reloadCollectJS(isACH) {

    // console.log('reloadCollectJS: ', this.state.velox_token_key, this.state.amount)
    var collectScript = document.querySelector("script[src='https://velox.transactiongateway.com/token/Collect.js']")
    if (collectScript) {
      console.log('removed collect script')
      collectScript.remove()
    }

        const script = document.createElement("script")
        script.src = "https://velox.transactiongateway.com/token/Collect.js"
        script.async = false
        script.setAttribute('data-tokenization-key', this.state.velox_token_key)
        script.setAttribute('data-country', 'US')
        script.setAttribute('data-currency', 'USD')
        script.setAttribute('data-price', this.state.amount)
        
        if (script.readyState) {  // only required for IE <9
          script.onreadystatechange = () => {
            if ( script.readyState === "loaded" || script.readyState === "complete" ) {
              script.onreadystatechange = null
              console.log('reloading collect')
              if (isACH) this.loadACHCollect()
              else this.loadCollect()
            }
          }
        } else {  //Others
          script.onload = () => {
            console.log('reloading collect')
            if (isACH) this.loadACHCollect()
            else this.loadCollect()
          }
        }
        document.body.appendChild(script)
        console.log('reloaded collect js')

  }
  unloadScript(scriptUrl) {
    // Find the script element with the specified URL
    const script = Array.from(document.getElementsByTagName('script')).find(s => s.src === scriptUrl)
    // console.log('script: ', script)
    //window.CollectJS.remove()
    // If the script element exists, remove it from the head element
    if (script) {
      console.log('removed collect script')
      script.remove()
    }
    
  }
  loadACHCollect() {
    console.log('loadACHCollect')
    
    window.CollectJS.configure({
      variant: 'inline',
      // styleSniffer: true,
      validationCallback: (field, valid, message) => {
        // console.log('ACH validationCallback: ', field, ' ', valid, ' ', message)
        this.fieldValidation({ field, valid, message })
      },
      fieldsAvailableCallback: () => {
        console.log('ach fields loaded')
        this.fieldsAvailable()
      },
      timeoutCallback: () => {
        console.log('timeoutCallback: ')
        this.submitError(`The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity`)
      },
      callback: (token) => {
        // console.log('token: ',token)
        this.finishSubmit(token)
      },
      fields: {
        ccnumber: {
          placeholder: 'Card Number',
          selector: '#ccnumber'
        },
        ccexp: {
          placeholder: 'Expiration Date (MM/YY)',
          selector: '#ccexp'
        },
        cvv: {
          placeholder: 'CVV',
          selector: '#cvv'
        },
        checkaccount: {
          placeholder: 'Account Number',
          title: 'Account Number',
          selector: '#checkaccount'
        },
        checkaba: {
          placeholder: 'Routing Number',
          title: 'Routing Number',
          selector: '#checkaba'
        },
        checkname: {
          placeholder: 'Name on Checking Account',
          title: 'Name on Checking Account',
          selector: '#checkname'
        },
        
      },
      "customCss": {
        "display": "block",
        "width": "100%",
        "padding": "0.375rem 0.75rem",
        "font-size": '1rem',
        "font-weight":'400',
        "line-height": "24px",
        "height": "38px",
        "color": "#212529",
        "background-color": "#fff",
        "background-clip": "padding-box",
        "border": "1px solid #ced4da",
        "-webkit-appearance": "none",
        "appearance": "none",
        "border-radius": "0.25rem",
        "transition": "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
        "text-transform": "none"
      }
    })
    console.log('loaded ACH collect')
  }
  loadCollect() {
    console.log('in loadCollect')
    
    window.CollectJS.configure({
        variant: 'inline',
        // styleSniffer: true,
        validationCallback: (field, valid, message) => {
          console.log('validationCallback: ', field, ' ', valid, ' ', message)
          this.fieldValidation({ field, valid, message })
        },
        fieldsAvailableCallback: () => {
          console.log('field loaded')
          this.fieldsAvailable()
        },
        timeoutCallback: () => {
          console.log('timeoutCallback: ')
          this.submitError(`The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity`)
        },
        callback: (token) => {
          console.log('token: ',token)
          this.finishSubmit(token)
        },
        fields: {
          ccnumber: {
            placeholder: 'Card Number',
            selector: '#ccnumber'
          },
          ccexp: {
            placeholder: 'Expiration Date (MM/YY)',
            selector: '#ccexp'
          },
          cvv: {
            placeholder: 'CVV',
            selector: '#cvv'
          },
          
          applePay: {
            style: {
              'button-style': 'white-outline',
              height: '40px',
            },
            requiredBillingContactFields: [
              'postalAddress',
              'name'
            ],
            type: 'check-out'
          },
          googlePay: {
            billingAddressRequired: true,
            billingAddressParameters: {
              format: 'FULL'
            },
            buttonType: 'checkout',
          }
        },
        "customCss": {
          "display": "block",
          "width": "100%",
          "padding": "0.375rem 0.75rem",
          "font-size": '1rem',
          "font-weight":'400',
          "line-height": "24px",
          "height": "38px",
          "color": "#212529",
          "background-color": "#fff",
          "background-clip": "padding-box",
          "border": "1px solid #ced4da",
          "-webkit-appearance": "none",
          "appearance": "none",
          "border-radius": "0.25rem",
          "transition": "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
          "text-transform": "none"
        }
    })
  }

  finishSubmit(response) {
    // console.log('finish submit: ', JSON.stringify(response))
    const {
      token,
      tokenType,
      card: { exp, number, type } = {},
      wallet: { billingInfo : { address1, address2, firstName, lastName, postalCode, city, state, country, phone } = {} } = {}
    } = response

    if (tokenType === 'googlePay' || tokenType === 'applePay') {
      this.setState( {
        firstName,
        lastName,
        address: `${address1}${address2 ? ' ' + address2 : ''}`,
        city,
        state,
        zip: postalCode,
        country,
        phone,
      })
    }
    this.completePayment({ token, exp, number, type, tokenType })

  }

  handleEmail({ canvas, email }) {
    const functions = getFunctions(app)
    const emailReceipt = httpsCallable(functions, 'onCall-emailReceipt')
    this.setState({ isSubmitting: true })
    const {
      merchantId,
      terminalId,
      accountName,
      datetime,
      expire,
      refId,
      signature,
      amount,
      orderId,
      invoiceRef,
    } = this.state
    // console.log(merchantId, terminalId, amount, datetime, expire, refId, signature, orderId)
    emailReceipt({ merchantId, terminalId, accountName, datetime, expire, refId, signature, amount, emailTo: email, file: canvas, orderId, invoiceRef }).then(result => {
      const {
        status
      } = result.data
      console.log(status)
      if (status ===  'Success') {
        // this.setState({ isSubmitting: false, alertMessage: status, complete: true, alertClass: 'alert alert-success alert-fixed' })
        window.location.reload(false)
      } else {
        this.setState({ isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
      }
      // 
    }).catch(err => {
      console.log('error: ', err.message)
      this.setState({ isSubmitting: false, alertMessage: err.message, alertClass: 'alert alert-danger alert-fixed' })
    })
  }

  payPalError(error, debug_id, type, url) {
    console.log('payPalError for debug_id',debug_id, error, type, url, merchantId, this.state.refId )
    const functions = getFunctions(app)
    const payPalError = httpsCallable(functions, 'onCall-payPalError')
    const {
      merchantId,
    } = this.state
    
    payPalError({ refId: this.state.refId, merchantId, error, debug_id, type, url }).then(() => {
 
    }).catch(err => {
      console.log('payPalError: ', err.message)
      this.setState({ isSubmitting: false, alertMessage: err.message, alertClass: 'alert alert-danger alert-fixed' })
    })
  }

  completePayPalPayment(request, response) {
    const {
      paymentSource,
    } = this.state
    const type = paymentSource
    console.log('completePayPalPayment for type',type )
    const functions = getFunctions(app)
    const makePayPalPayment = httpsCallable(functions, 'onCall-makePayPalPayment')

    const {
      merchantId,
      terminalId,
      datetime,
      expire,
      refId,
      signature,
      amount,
      firstName,
      lastName,
      address,
      city,
      state,
      zip,
      email,
      orderId,
      recaptcha,
      capture_signature,
      phone,
      authCode,
    } = this.state
    
    makePayPalPayment({ recaptcha, capture_signature, merchantId, terminalId, datetime, expire, refId,
      signature, amount, firstName, lastName, address, city, state, zip, type, orderId, authCode, phone, request, response }).then(result => {
      const {
        status,
        authCode,
        amountPaid,
        process,
        paymentType,
        cardType,
        isInternal,
        last4,
        avsResponse,
        paymentDate,
      } = result.data

      console.log('makePayPalPayment result.data: ', JSON.stringify(result.data))
      console.log('isInternal: ', isInternal)
      if (isInternal) {
        if (status ===  'Success') {
          this.setState({ 
            isComplete: true,
            alertMessage: null, 
            alertClass: null, 
            completeMessage: 'Approved',
            isSubmitting: false,
            receipt: false,
          })
        } else {
          this.setState({ isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
        }
        console.log('posting message: ')
        window.top.postMessage(JSON.stringify({
          error: (status !==  'Success') ? true : false,
          message: {
            refId,
            status,
            orderId,
            firstName,
            lastName,
            address,
            city,
            state,
            zip,
            phone,
            email,
            authCode,
            amountPaid,
            process,
            paymentType,
            last4,
            cardType,
            avsResponse,
            paymentDate,
          }
        }),
          '*'
        )
      } else {
        if (status ===  'Success') {
          this.setState({ 
            isSubmitting: false, 
            authCode, 
            type, 
            alertMessage: null, 
            amountPaid, 
            process,
            paymentType,
            cardType,
            receipt: true, 
            alertClass: null,
            paymentDate,
          })
        } else {
          this.setState({ isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
        }
      }
      // window.location.reload(false)
    }).catch(err => {
      console.log('posting error message ')
      window.top.postMessage(JSON.stringify({
        error: true,
        message: {
          status: err.message,
        }
      }),
        '*'
      )
      console.log('error: ', err.message)
      this.setState({ isSubmitting: false, alertMessage: err.message, alertClass: 'alert alert-danger alert-fixed' })
    })
  }
  handleCancelAlert() {
    console.log('cancel alert')
    this.setState({ alertMessage: undefined, alertClass: undefined })
  }
  handleWex() {
    console.log('handleWex')
    this.setState({ payWithWex : true })
    this.setState({ payWithVoyager : false })
    this.setState({ alertClass: null })
    this.setState({ showCC : false })
  }
  handleVoyager() {
    console.log('handleVoyager')
    this.setState({ payWithVoyager : true })
    this.setState({ payWithWex : false })
    this.setState({ alertClass: null })
    this.setState({ showCC : false })
  }
  setIsEditing() {
    this.setState({ fleetediting : true })
  }
  handleSaveFleetItems(items) {
    console.log("Items saved from child:", items)
    
    this.setState({ fleetitems : items })
    this.setState({ fleetediting : false })
    this.setState({ fleettotal : items.reduce(
      (sum, item) => sum + item.quantity * item.price,
      0
    ) })
    
  }
  async completePayment({ token, exp, number, type, tokenType }) {
    const functions = getFunctions(app)
    const makePayment = httpsCallable(functions, 'onCall-makePayment')

    const {
      merchantId,
      terminalId,
      datetime,
      expire,
      refId,
      signature,
      amount,
      firstName,
      lastName,
      address,
      city,
      state,
      zip,
      orderId,
      recaptcha,
      capture_signature,
      phone,
      email,
      payWithACH,
    } = this.state
    try {
      if (payWithACH) { 
        type = 'ach'
      }
      const result = await makePayment({ recaptcha, capture_signature, tokenType, merchantId, terminalId, datetime, expire, refId, signature, amount, firstName, lastName, address, city, state, zip, token, exp, number, type, orderId, phone })
      const {
        status,
        authCode,
        amountPaid,
        process,
        paymentType,
        last4,
        cardType,
        avsResponse,
        isInternal,
        isFinal,
        finalMsg, 
        paymentDate,
        responsetext
      } = result.data
      console.log('result.data: ', JSON.stringify(result.data))

      if (isInternal) {
        if (status ===  'Success') {
          this.setState({ 
            isComplete: true,
            alertMessage: null, 
            alertClass: null, 
            completeMessage: 'Approved',
            isSubmitting: false,
            receipt: false,
          })
        } else {
          //relaod collectjs and recaptcha
          this.handleClear()
          // this.reloadCollectJS(false)
          this.loadCollect()
          if (isFinal) this.setState({ invalid: true, invalidMessage: status + '.  ' + finalMsg })
          this.setState({ submitDisabled: true, isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
          console.log('reloaded collectjs ')
        }
        window.top.postMessage(JSON.stringify({
          error: (status !==  'Success') ? true : false,
          message: {
            refId,
            status,
            orderId,
            firstName,
            lastName,
            address,
            city,
            state,
            zip,
            phone,
            email,
            authCode,
            amountPaid,
            process,
            paymentType,
            last4,
            cardType,
            avsResponse,
            paymentDate,
          }
        }),
          '*'
        )
      } else {
        if (status ===  'Success') {
          this.setState({ 
            isSubmitting: false, 
            authCode, 
            number,
            type, 
            alertMessage: null, 
            amountPaid, 
            process,
            paymentType,
            last4,
            cardType,
            avsResponse,
            receipt: true, 
            alertClass: null,
            paymentDate,
          })
        } else {
          //reload collectjs for Max Amount, CVV and AVS errors 
          // Max Amount errors should be caught durimg paymentUdl API call, but in case existing links are already there, lets catch them here, and handle properly

          if ((status && status.startsWith('Could not process. Address')) || status==='CVV is not valid' || responsetext==='Amount exceeds the maximum ticket allowed') {
              this.handleClear()
              this.loadCollect()
              if (isFinal) this.setState({ invalid: true, invalidMessage: status + '.  ' + finalMsg })
              this.setState({ submitDisabled: true, isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
          } else {
            //relaod collectjs and recaptcha
            this.handleClear()
            // this.reloadCollectJS(false)
            this.loadCollect()
            if (isFinal) this.setState({ invalid: true, invalidMessage: status + '.  ' + finalMsg })
            this.setState({ submitDisabled: true, isSubmitting: false, alertMessage: status, alertClass: 'alert alert-danger alert-fixed' })
            console.log('reloaded collectjs ')
          }
        }
      }
      // window.location.reload(false)
    } catch(err) {
      console.log('error: ', err.message)
      window.top.postMessage(JSON.stringify({
        error: true,
        message: {
          status: err.message,
        }
      }),
        '*'
      )
      const { code, details: { message = '' } = {} } = JSON.parse(JSON.stringify(err))
      console.log('err: ', code, message)
      if (err.message === 'ECONNRESET') {
        this.setState({ isSubmitting: false, invalid: true, invalidMessage: message })
      } else {
        this.setState({ isSubmitting: false, invalid: true, invalidMessage: err.message })
      }
    }
  }

  fieldValidation({ field, valid, message }) {
    this.setState((state) => {
      const fields = state.fields
      fields[field] = {
        valid,
        message,
      }
      return {
        fields
      }
    })
    
    console.log('this.state.payWithACH', this.state.payWithACH)

    if (this.state.subbmitting && !valid) {
      if (this.state.payWithACH && (field=='checkaba'|| field=='checkaccount'|| field=='checkname')) {
        this.setState({ isSubmitting: false, alertMessage: `${field} ${message}`, alertClass: 'alert alert-danger alert-fixed' })
      }
      if (!this.state.payWithACH && (field=='ccnumber'|| field=='ccexp'|| field=='cvv')) {
        this.setState({ isSubmitting: false, alertMessage: `${field} ${message}`, alertClass: 'alert alert-danger alert-fixed' })
      }
    } else if (!valid) {
      if (this.state.payWithACH && (field=='checkaba'|| field=='checkaccount'|| field=='checkname')) {
        this.setState({ alertMessage: `${field} ${message}`, alertClass: 'alert alert-danger alert-fixed' })
      }
      if (!this.state.payWithACH && (field=='ccnumber'|| field=='ccexp'|| field=='cvv')) {
        this.setState({ alertMessage: `${field} ${message}`, alertClass: 'alert alert-danger alert-fixed' })
      }
      
    }
    this.updateSubmitDisabled()
  }

  fieldsAvailable() {
    this.setState({ fieldsReady: true })
  }

  submitError(message) {
    console.log('submitError', message)
    this.setState({ isSubmitting: false, alertMessage: `${message}`, alertClass: 'alert alert-danger alert-fixed' })
  }

  handleClear() {
    console.log('handleClear', this.signaturePadRef, this.signaturePadRef.current)
    if (this.signaturePadRef && this.signaturePadRef.current) this.signaturePadRef.current.clear()
    // else this.setState({ sigPadKey: Date.now() })

    this.setState({ signatureHidden: true })
    this.setState({ capture_signature: undefined })
    this.setState({ showCaptchaSignature: false })
    this.setState({ showCaptchaSignature: !this.state.isInternal })
    this.setState({ recaptcha:'' })
   
    // this.signaturePadRef.current.clear()
    this.updateSubmitDisabled()
  }

  handleGetSignature() {
    if (!this.signaturePadRef.current.isEmpty()) {
      const data = this.signaturePadRef.current.toDataURL()
      // console.log('data: ', data)
      this.setState({ capture_signature: data })
      this.toggleSignature()
      this.updateSubmitDisabled()
    }
  }

  updateSubmitDisabled() {
    this.setState((state) => {
      // const hasSignature = !!state.capture_signature 
      // const hasRecaptcha = !!state.recaptcha 
      const fieldsValid = Object.keys(state.fields).reduce((retBol, field) => {
        // console.log('field: ' + field + ' - ' + JSON.stringify(state.fields[field]))
        // console.log('retBol - ach?:', retBol, this.state.payWithACH)
        if (this.state.payWithACH && (field=='checkaba'|| field=='checkaccount'|| field=='checkname')) {
          return retBol && (state.fields[field].valid || false)
        } else if (!this.state.payWithACH && (field=='ccnumber'|| field=='ccexp'|| field=='cvv')){
          return  retBol && (state.fields[field].valid || false)
        } else return retBol
        
      }, true)
      // console.log('fieldsValid: ', !fieldsValid)
      // console.log('hasRecaptcha: ', !hasRecaptcha)
      // console.log('hasSignature: ', !hasSignature)
      return {
        //submitDisabled: !fieldsValid || !hasRecaptcha || !hasSignature
        submitDisabled: !fieldsValid 
      }
    })
  }
  onPhoneChange(event) {
    console.log("onPhoneChange value:", event.target.value, this.state.phone)
    // console.log("onPhoneChange merchantId:", this.state.merchantId)
    
    this.setState({ phone: event.target.value })
    // console.log("calling loadLendResults", event.target.value)
    if (this.state.hasCFP && !this.state.hideAuxillaryPayments) this.loadLendResults({ merchantId: this.state.merchantId, cfpPartnerKey: this.state.cfpPartnerKey, phone: event.target.value.replace(/\D/g, ""), amount: this.state.amount })
  }
  onChange(value) {
    // console.log("Captcha value:", value)
    this.setState({ recaptcha: value })
    this.updateSubmitDisabled()
  }
  onAddressChange(event) {
    this.setState({ address: event.target.value })
    this.setState({ reloadSynchrony: true })
    setTimeout(() => {
      this.setState({ reloadSynchrony: false }) // 2. Reload it after a short delay
    }, 10) // Delay needed so React has time to unmount first
  }
  onZipChange(event) {
    
    this.setState({ zip: event.target.value })
    this.setState({ reloadSynchrony: true })
    setTimeout(() => {
      this.setState({ reloadSynchrony: false }) // 2. Reload it after a short delay
    }, 10) // Delay needed so React has time to unmount first

  }
  handleShowCC() {
    this.setState({ showCC: true, showCaptchaSignature: !this.state.isInternal })
    this.setState({ payWithWex : false })
    this.setState({ payWithVoyager : false })
    this.loadCollect()
  }

  // Function to darken a HEX color
  darkenColor(hex, percent) {
    let num = parseInt(hex ? hex.slice(1) : '#36454F'.slice(1), 16) // Convert HEX to Integer
    let r = (num >> 16) - percent // Reduce Red
    let g = ((num >> 8) & 0x00ff) - percent // Reduce Green
    let b = (num & 0x0000ff) - percent // Reduce Blue
    
    // Ensure values don't go below 0
    r = r < 0 ? 0 : r
    g = g < 0 ? 0 : g
    b = b < 0 ? 0 : b

    return `rgb(${r}, ${g}, ${b})` // Convert back to RGB
  }


  handleSubmit(event) {
    event.preventDefault()
    this.setState({ alertMessage: null })
    const hasSignature = this.signaturePadRef.current && !this.signaturePadRef.current.isEmpty()
    if (hasSignature) {
      const data = this.signaturePadRef.current.toDataURL()
      this.toggleSignature()
      this.setState({ capture_signature: data })
    }
    const hasRecaptcha = !!this.state.recaptcha 
    console.log('hasSignature: ' + hasSignature)
    console.log('hasRecaptcha: ' + hasRecaptcha)
    const {
      firstName,
      lastName,
      address,
      city,
      state,
      zip
    } = this.state
    if (!firstName) {
      return this.submitError(`Billing First Name is required`)
    }
    if (!lastName) {
      return this.submitError(`Billing Last Name is required`)
    }
    if (!address) {
      return this.submitError(`Billing Street Address is required`)
    }
    if (!city) {
      return this.submitError(`Billing City is required`)
    }
    if (!state) {
      return this.submitError(`Billing State/Province is required`)
    }
    if (!zip) {
      return this.submitError(`Billing Zip/Postal Code is required`)
    }
    if (this.state.isInternal) {
      this.setState({ isSubmitting: true })
      console.log('starting payment request')
      window.CollectJS.startPaymentRequest()
    } else {
      if (!hasSignature && !this.state.hideSignature) {
        return this.submitError(`Signature is required`)
      } else if (!hasRecaptcha) {
        return this.submitError(`Recaptcha is required`)
      } else {
        this.setState({ isSubmitting: true })
        console.log('starting payment request')
        window.CollectJS.startPaymentRequest()
      }
    }
    
  }
  toggleACH() {
    console.log('toggleACH')
    //this.unloadScript('https://velox.transactiongateway.com/token/Collect.js')
    //window.CollectJS.closePaymentRequest()

    //disable button
    this.setState((state) => {
      const fieldsValid = Object.keys(state.fields).reduce((retBol, field) => {
        console.log('toggle field', field,retBol )
        state.fields[field].valid = false
        return false
      }, true)
      console.log('fieldsValid: ', fieldsValid)
      return {
        submitDisabled: !fieldsValid 
      }
    })

    
    this.updateSubmitDisabled()
    console.log('toggleACH state', this.state.payWithACH)
    if (this.state.payWithACH) { 
      //set ach fields to null
      this.setState({ payWithACH: false }) 
      this.reloadCollectJS(false)
      //this.loadCollect()
    } else { 
      console.log('loading ACHCollect')
      //set cc fields to null
      var ccnum = document.getElementById('ccnumber')
      console.log('ccnumber: ', ccnum)
      ccnum.remove()
      this.setState({ payWithACH: true })
      this.reloadCollectJS(true)
      //this.loadACHCollect()
    }
    
  }
  toggleSignature() {
    this.setState((state) => { 
      return { signatureHidden: !state.signatureHidden }
    })
  }
  dBuyStarted = () => {
    console.log('dBuyStarted')
    this.setState({ dBuyStarted : true })
  }
  dBuyFinished = async (data, fullPromos) => {
    console.log('*** dBuyFinished', JSON.stringify(data))
    console.log('*** dBuyFinished', JSON.stringify(fullPromos))

    this.setState({ dBuyClosed: true })
    this.setState({  alertMessage: '' })
    const functions = getFunctions(app)
    const lookupSynchTxn = httpsCallable(functions, 'onCall-lookupSynchTxn')
    const lookupresp = await lookupSynchTxn(data)
    console.log('*** lookupSynchTxn', JSON.stringify(lookupresp))

    if (lookupresp && lookupresp.data.txnResponse && lookupresp.data.txnResponse.creditAuthorizationInfo 
      && lookupresp.data.txnResponse.creditAuthorizationInfo.transactionCode) {
      if (lookupresp.data.txnResponse.creditAuthorizationInfo.transactionCode==='033') {
        //finalize txn
        this.setState({ 
          dBuyNeedsFinal : true
        })

        const finalizeSynchTxn = httpsCallable(functions, 'onCall-finalizeSynchTxn')
        const resp = await finalizeSynchTxn(data)
        console.log('*** finalizeSynchTxn', JSON.stringify(resp))

        if (resp.data.authCode) {
          //set promo codes for receipt page
          let promoDescr = ''
          if (resp.data.synchronyPromoCode) promoDescr = fullPromos.get(resp.data.synchronyPromoCode)

          this.setState({ 
            synchronyPromoCode: resp.data.synchronyPromoCode,
            synchronyPromoDescr: promoDescr,
          })

          this.setState({ 
            authCode: resp.data.authCode,
            isSubmitting: false, 
            type: 'CFP', 
            alertMessage: null, 
            amountPaid: this.state.amount, 
            process: 't2p',
            paymentType: 'Sale',
            cardType: 'Synchrony',
            receipt: true, 
            alertClass: null,
            paymentDate: resp.data.paymentDate,
          })
          return
        } else {

          // show Delinced message
          if (resp.data.error && resp.data.error.includes('Declined')) {
            this.setState({ isSubmitting: false, alertMessage: `${resp.data.error}`, alertClass: 'alert alert-danger alert-fixed' })
            //log error with firebase
            const paymentError = httpsCallable(functions, 'onCall-paymentError')
            const peresp = await paymentError({ entryMethod: 'Synchrony', errorReason: JSON.stringify(resp.data.error), 
              merchantId: this.state.merchantId, refId: this.state.refId })
            console.log('paymentError resp: ' + JSON.stringify(peresp))
          }
          // show CALL FOR AUTH message
          if (resp.data.error && resp.data.error.includes('CALL FOR')) {
            this.setState({ isSubmitting: false, alertMessage: `${resp.data.error}`, alertClass: 'alert alert-danger alert-fixed' })
            //log error with firebase
            const paymentError = httpsCallable(functions, 'onCall-paymentError')
            const peresp = await paymentError({ entryMethod: 'Synchrony', errorReason: JSON.stringify(resp.data.error), 
              merchantId: this.state.merchantId, refId: this.state.refId })
            console.log('paymentError resp: ' + JSON.stringify(peresp))
          }
        }
        //finalize txn
        this.setState({ 
          dBuyNeedsFinal : false
        })

      } else {
        // do nothing, cant show the response it might be address verification of customer just closed window
        //log error with firebase
        const paymentError = httpsCallable(functions, 'onCall-paymentError')
        const resp = await paymentError({ entryMethod: 'Synchrony', errorReason: JSON.stringify(lookupresp), merchantId: this.state.merchantId, refId: this.state.refId })
        console.log('paymentError resp: ' + JSON.stringify(resp))
      }
    } else {
      // this.setState({ isSubmitting: false, alertMessage: 'Could not lookup transaction for id ' + data.txnToken, alertClass: 'alert alert-danger alert-fixed' })
      //log error with firebase
      const paymentError = httpsCallable(functions, 'onCall-paymentError')
      const resp = await paymentError({ entryMethod: 'Synchrony', errorReason: JSON.stringify(lookupresp), merchantId: this.state.merchantId, refId: this.state.refId })
      console.log('paymentError resp: ' + JSON.stringify(resp))
    }
    //need to get another token for DBuy in case they start again
    this.setState({ isSynchrony: false })
    this.setState({ isSynchrony: true })
    this.setState({ dBuyClosed: false })
    

  }


  finishPayPal = (code, paymentSource, debug_id, url, payer_email, request, response) => {
    console.log('in finishPayPal: '+ code + ' ' + paymentSource)
    if (code.startsWith('Error')) {
      this.payPalError( code, debug_id, 'PayPal', url  )
      this.submitError(code)
    } else {
      console.log('success paypal: ' + code)
      this.setState({ payer_email : payer_email })
      this.setState({ authCode : code })
      this.setState({ paymentSource : paymentSource })
      this.setState({ palPalComplete : true })
      this.setState({ receipt : true })
      this.completePayPalPayment( request, response )
    }
  }

  formatPhoneNumber = (phone) => {
    if (!phone) return ""
    
    // Remove all non-numeric characters
    let cleaned = phone.replace(/\D/g, "")
  
    // Remove country code if it's 11 digits and starts with "1"
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      cleaned = cleaned.substring(1)
    }
  
    // Ensure it's a 10-digit number
    if (cleaned.length !== 10) return phone
  
    // Format as (999) 999-9999
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }

  handleClose = () => {
    window.close()
  }

  render() {
    
    if (this.state.receipt) { // eslint-disable-line no-constant-condition
      return (
        <div>
          { this.state.alertMessage && (
            <div className={this.state.alertClass} role="alert" onClick={this.handleCancelAlert}>
              {this.state.alertMessage}
            </div>
          )}
          { this.state.isSubmitting  && (
            <div id="overlay">
              <div className="spinner"></div>
            </div>
          )}

          { !this.state.palPalComplete && (
          <PaymentReceipt {...this.state} handleEmail={this.handleEmail}/>
          )}

          { this.state.palPalComplete && (
            <PayPalPaymentReceipt {...this.state} handleEmail={this.handleEmail}/>
          )}

          
          
        </div>
      )
    }
    if (this.state.invalid) {
      return (
        <div className="App">
          <div className="container-fluid">
            <div className="row justify-content-center m-4">
            <div className="card">
              <div className="card-body">
                <h1>{this.state.invalidMessage}</h1>
              </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    if (this.state.isComplete) {
      return (
        <div className="App">
          <div className="container-fluid">
            <div className="row justify-content-center m-4">
            <div className="card">
              <div className="card-body">
                <h1>{this.state.completeMessage}</h1>
              </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    if (this.state.isCanceled) {
      return (
        <div className="App">
          <div className="container-fluid">
            <div className="row justify-content-center m-4">
            <div className="card">
              <div className="card-body">
                <h1>This link has been Canceled</h1>
              </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    if (this.state.notInvalid) {
      return (
        <div className="App">
          <div className="container-fluid">
            <div className="row justify-content-center m-4">
            <div className="card">
              <div className="card-body">
                <h1>This link is not valid</h1>
              </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    if (!this.state.merchantId) {
      return (
        <div className="App">
          { this.state.alertMessage ? (
          <div className={this.state.alertClass} role="alert">
            {this.state.alertMessage}
          </div>
        ) : (
          <div className="text-center">
            <div className="spinner-border m-5" style={{ width: 5 + 'rem', height: 5 + 'rem' }} role="status">
            </div>
          </div>
        )}
        </div>
      )
    }
    const {
      isInternal,
      hideHeader,
    } = this.state
    return (
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="card bg-light mt-2" style={{ width: "35rem" }}>
            {this.state.canClosePage && <button
            onClick={this.handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              width: "34px",
              height: "34px",
              backgroundColor: "Gainsboro",
              color: "red",
              border: "none",
              borderRadius: "4px",
              fontSize: "18px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "red"
              e.target.style.color = "white"
              e.target.title = "Close Page"
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "Gainsboro"
              e.target.style.color = "red"
            }}
            >
              ✕
            </button>}
            { this.state.isSubmitting && (
              <div id="overlay">
                <div className="spinner"></div>
              </div>
            )}

            { !isInternal && !hideHeader && this.state.accountImage && (
              <div className="row justify-content-center">
                <div className="col-10 mt-2">
                  <div style={{ 
                    display: "inline-block", 
                    border: "1px solid #dee2e6", 
                    borderRadius: "5px",
                    padding: "5px", 
                    maxWidth: "100%", 
                  }}>
                    <img 
                      src={this.state.accountImage} 
                      alt="image" 
                      className="rounded img-fluid" 
                      style={{ 
                        maxWidth: "100%", 
                        maxHeight: "170px", 
                        height: "auto", 
                        objectFit: "contain", 
                        display: "block" // Prevents extra spacing below the image
                      }} 
                    />
                  </div>
                </div>
              </div>
            )}
            { this.state.alertMessage && (
              <div className={this.state.alertClass} role="alert">
                {this.state.alertMessage}
              </div>
            )}
            { !isInternal && !hideHeader && <h2 style={{ color: this.state.hexColorCode || '#36454F' }}><b>{this.state.accountName}</b></h2>}
            { !isInternal && !hideHeader && <h6>{this.state.accountPhone}</h6>}
            { !isInternal && !hideHeader && <h6>{this.state.accountStreet}</h6>}
            { !isInternal && !hideHeader && <h6>{this.state.accountCity}, {this.state.accountState} {this.state.accountZip}</h6>}
            { !hideHeader && (this.state.showOrderId || !this.state.worldnetUrl || this.state.makeModel) && (
              <div className="row justify-content-center my-3 ">
                <div className="col-12 redshadow">
                  <div style={{ 
                    border: "2px solid #7d7d7d", 
                    borderRadius: "5px",
                    padding: "5px", 
                    maxWidth: "100%", 
                    boxShadow: "0px 10px 10px -10px #353535",
                  }}>
                    { this.state.showOrderId && 
                    <div className="row mt-1 g-0">
                      <div className="col text-start" style={{ color: this.state.hexColorCode || '#36454F' }}><b>Order #:</b></div>
                      <div className="col text-end">{this.state.invoiceUrl ? (<a target="_blank" href={this.state.invoiceUrl}>{this.state.orderId}</a>) : this.state.orderId}</div>
                    </div>
                    }
                    { !this.state.showOrderId && this.state.invoiceUrl && 
                    <div className="row mt-1 g-0">
                      <div className="col text-start" style={{ color: this.state.hexColorCode || '#36454F' }}><b>Invoice Link:</b></div>
                      <div className="col text-end">{(<a target="_blank" href={this.state.invoiceUrl}>Link</a>)}</div>
                    </div>
                    }
                    { !this.state.worldnetUrl && <div className="row mt-1 g-0">
                      <div className="col text-start" style={{ color: this.state.hexColorCode || '#36454F' }}><b>Amount Due:</b></div>
                      <div className="col text-end">${this.state.amount}</div>
                    </div>}
                    {this.state.makeModel && <div className="row mt-1 g-0">
                      <div className="col text-start" style={{ color: this.state.hexColorCode || '#36454F' }}><b>Make & Model:</b></div>
                      <div className="col text-end">{this.state.makeModel}</div>
                    </div>}
                  </div>
                </div>
              </div>
            )}
            <br/>
            { this.state.worldnetUrl ? (
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <iframe width="534" height="600" src={this.state.worldnetUrl}></iframe>
                </div>
                {  (this.state.hasPayPal || this.state.hasVenmo) && !this.state.hideAuxillaryPayments && this.state.payPalMerchantStatus && this.state.payPalMerchantStatus==='MERCHANT_ACTIVATED' && !this.state.authOnly && (
                    <div>
                      <hr style={{ height: '10px', visibility: 'hidden' }} />
                      <PayPal props={this.state} finishPayPal={this.finishPayPal} 
                        payPalId={this.state.payPalId} service={this.state.payPalService} platformfee={this.state.payPalPlatformFee} 
                        hidePayLater={this.state.Hide_Paypal_Pay_Later}/> 
                    
                    </div>
                  )}

                  { this.state.dBuyStarted && this.state.dBuyNeedsFinal && (
                        <div className="synchoverlay" >
                          <div className="synchoverlay-card" role="dialog" aria-modal="true">
                            <div className="synchspinnertext" >Finalizing Synchrony Transaction, please do not leave this page<div className="cfpspinner"></div></div>
                          </div>
                        </div>
                      ) 
                    }
                    { this.state.dBuyStarted && this.state.dBuyClosed && !this.state.dBuyNeedsFinal && (
                        <div className="synchoverlay" >
                          <div className="synchoverlay-card" role="dialog" aria-modal="true">
                          <div className="synchspinnertext" >Checking information, please do not leave this page<div className="cfpspinner"></div></div>
                          </div>
                        </div>
                      ) 
                    }
                  <br/>

                  { this.state.lendResultLoading && (
                    <div className="cfpspinnertext">Loading Lend Results</div>
                  )}

                  { !this.state.lendResultLoading && this.state.lendApplyUrl && !this.state.isSynchrony && (
                    <div className="box" style={{ borderLeft: `5px solid ${this.state.hexColorCode}` }}>
                      <b>
                        <h6>
                          {this.state.lendResult && (<div style={{ color: 'white' }} dangerouslySetInnerHTML={{ __html: this.state.lendResult }} />)}
                          {this.state.lendApplyUrl && (<div style={{ color: 'white' }}>
                            <a 
                              target="_blank"
                              href={this.state.lendApplyUrl}
                              className="btn btn-primary btn-sm"
                              style={{
                                backgroundColor: this.state.hexColorCode,
                                border: "none",
                                transition: "background-color 0.3s ease",
                              }}
                              onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                              onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}>
                              <b>Apply Now</b>
                            </a>
                          </div>)}
                        </h6>  
                      </b>
                    </div>   
                  )}
                  
                  {  !this.state.reloadSynchrony && !this.state.lendResultLoading && this.state.lendResult && this.state.isSynchrony && (
                    <div className="inline">
                      <SynchDbuy key={this.state.synchkey} address={this.state.address} zip={this.state.zip} dBuyStarted={this.dBuyStarted} dBuyFinished={this.dBuyFinished} props={this.state} />
                    </div>   
                  )}
              </div>
            ) : this.state.payrocFields ? (
              <div className="container-fluid">
                              <form>
                {//<div className="myborder mb-1">
                }
                  <fieldset>
                    <div className="row mt-1 g-0">
                      <div className="col">
                        <input
                          type="text"
                          name="firstName"
                          className="form-control bodytext"
                          placeholder="First name"
                          onChange={event => this.setState({ firstName: event.target.value })}
                          value={this.state.firstName }
                        />
                      </div>
                      <div className="col ms-1">
                        <input
                          type="text"
                          name="lastName"
                          className="form-control bodytext"
                          placeholder="Last name"
                          onChange={event => this.setState({ lastName: event.target.value })}
                          value={this.state.lastName}
                          size="30"
                        />
                      </div>
                    </div>
                    <div style={{ height: '5px', visibility: 'hidden' }} className="card-holder-name"></div>
                    <div style={{ height: '0px', visibility: 'hidden' }} className="card-holder-name-error error-message"></div>
                    <div> 
                      <input
                        type="text"
                        name="phone"
                        className="form-control bodytext"
                        placeholder="Phone"
                        onChange={this.onPhoneChange}
                        value={this.formatPhoneNumber(this.state.phone)}
                        size="30"
                      />
                    </div>
                    <div className="mt-1"> 
                      <input
                        type="text"
                        name="address"
                        className="form-control bodytext"
                        placeholder="Street address"
                        onChange={this.onAddressChange}
                        value={this.state.address}
                        size="30"
                      />
                    </div>
                    <div className="row mt-1 g-0">
                    <div className="col"> 
                      <input
                        type="text"
                        name="city"
                        className="form-control bodytext"
                        placeholder="City"
                        onChange={event => this.setState({ city: event.target.value })}
                        value={this.state.city}
                        size="30"
                      />
                    </div>
                    <div className="col ms-1"> 
                      <input
                        type="text"
                        name="state"
                        className="form-control bodytext"
                        placeholder="State/Province"
                        onChange={event => this.setState({ state: event.target.value })}
                        value={this.state.state}
                        size="30"
                      />
                    </div>
                    </div>
                    <div className="col mt-1 g-0"> 
                      <input
                        type="text"
                        name="zip"
                        className="form-control bodytext"
                        placeholder="Zip/Postal Code"
                        onChange={this.onZipChange}
                        value={this.state.zip}
                        size="30"
                      />
                    </div>
                    <div className=" mt-1">
                      <div className="card-number"></div>
                      <div className="card-number-error error-message"></div>
                      
                      <div className="row">
                        <div className="col">
                          <div className="card-expiry-wrapper">

                          <div className="card-expiry"></div>
                          <div className="card-expiry-error error-message"></div>
                          </div>
                        </div>
                          <div className="col">
                            <div className="card-cvv-wrapper">

                            <div className="card-cvv"></div>
                            <div className="card-cvv-error error-message"></div>
                            </div>
                          </div>
                      </div>
                      {!this.state.hideSignature && (this.state.showCaptchaSignature && !this.state.disableCC && this.state.signatureHidden && !this.state.capture_signature ? ( 
                        <div className="mt-1"> 
                        <input type="text" name="fakenameremembered" style={{ display: 'none' }} />
                          <input
                            type="text"
                            name="no_autofill_123456"
                            autoComplete="new-signature"
                            className="form-control"
                            placeholder="Signature"
                            onClick={this.toggleSignature}
                          />
                        </div>
                      ) : this.state.showCaptchaSignature &&  this.state.signatureHidden && this.state.capture_signature ? (
                        <div className="form-control mt-1" onClick={this.toggleSignature}>
                          <img src={this.state.capture_signature} alt="image" className="img-fluid"/>
                        </div>
                      ) : this.state.showCaptchaSignature ? (
                        <div>
                          <div className="mt-1 form-control">
                            <SignaturePad key={this.state.sigPadKey} ref={this.signaturePadRef}/>
                          </div>
                          <div className="mt-1 mb-1">
                            <button type="button" onClick={this.handleClear} className="btn btn-light">Clear</button>
                          </div>
                        </div> 
                      ) : <div/> )}
                      
                        
                      { this.state.showCaptchaSignature ? (
                      <div className="mt-1 justify-content-center">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey="6LeajoYgAAAAAAipHXxCDX8k3zOIo8tJ4IDd-MQ6"
                          onChange={this.onChange}
                        />  
                      </div>
                      ) : <div/>}
                      <div className="row mt-1 g-0">
                        <div id="surcharge-disclosure" ></div>
                      </div>
                      <div className="card-submit submit-button"></div>
                    </div>
                  </fieldset> 
              </form>
                {  (this.state.hasPayPal || this.state.hasVenmo) && !this.state.hideAuxillaryPayments && this.state.payPalMerchantStatus && this.state.payPalMerchantStatus==='MERCHANT_ACTIVATED' && !this.state.authOnly && (
                    <div>
                      <hr style={{ height: '10px', visibility: 'hidden' }} />
                      <PayPal props={this.state} finishPayPal={this.finishPayPal} 
                        payPalId={this.state.payPalId} service={this.state.payPalService} platformfee={this.state.payPalPlatformFee} 
                        hidePayLater={this.state.Hide_Paypal_Pay_Later}/> 
                    
                    </div>
                  )}

                  { this.state.dBuyStarted && this.state.dBuyNeedsFinal && (
                        <div className="synchoverlay" >
                          <div className="synchoverlay-card" role="dialog" aria-modal="true">
                            <div className="synchspinnertext" >Finalizing Synchrony Transaction, please do not leave this page<div className="cfpspinner"></div></div>
                          </div>
                        </div>
                      ) 
                    }
                    { this.state.dBuyStarted && this.state.dBuyClosed && !this.state.dBuyNeedsFinal && (
                        <div className="synchoverlay" >
                          <div className="synchoverlay-card" role="dialog" aria-modal="true">
                          <div className="synchspinnertext" >Checking information, please do not leave this page<div className="cfpspinner"></div></div>
                          </div>
                        </div>
                      ) 
                    }
                  <br/>

                  { this.state.lendResultLoading && (
                    <div className="cfpspinnertext">Loading Lend Results</div>
                  )}

                  { !this.state.lendResultLoading && this.state.lendApplyUrl && !this.state.isSynchrony && (
                    <div className="box" style={{ borderLeft: `5px solid ${this.state.hexColorCode}` }}>
                      <b>
                        <h6>
                          {this.state.lendResult && (<div style={{ color: 'white' }} dangerouslySetInnerHTML={{ __html: this.state.lendResult }} />)}
                          {this.state.lendApplyUrl && (<div style={{ color: 'white' }}>
                            <a 
                              target="_blank"
                              href={this.state.lendApplyUrl}
                              className="btn btn-primary btn-sm"
                              style={{
                                backgroundColor: this.state.hexColorCode,
                                border: "none",
                                transition: "background-color 0.3s ease",
                              }}
                              onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                              onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}>
                              <b>Apply Now</b>
                            </a>
                          </div>)}
                        </h6>  
                      </b>
                    </div>   
                  )}
                  
                  {  !this.state.reloadSynchrony && !this.state.lendResultLoading && this.state.lendResult && this.state.isSynchrony && (
                    <div className="inline">
                      <SynchDbuy key={this.state.synchkey} address={this.state.address} zip={this.state.zip} dBuyStarted={this.dBuyStarted} dBuyFinished={this.dBuyFinished} props={this.state} />
                    </div>   
                  )}
              </div>
            ) : (
              <form onSubmit={this.handleSubmit}>
                {//<div className="myborder mb-1">
                }
                  <fieldset>
                    <div className="row mt-1 g-0">
                      <div className="col">
                        <input
                          type="text"
                          name="firstName"
                          className="form-control bodytext"
                          placeholder="First name"
                          onChange={event => this.setState({ firstName: event.target.value })}
                          value={this.state.firstName }
                        />
                      </div>
                      <div className="col ms-1">
                        <input
                          type="text"
                          name="lastName"
                          className="form-control bodytext"
                          placeholder="Last name"
                          onChange={event => this.setState({ lastName: event.target.value })}
                          value={this.state.lastName}
                          size="30"
                        />
                      </div>
                    </div>
                    <div className="mt-1"> 
                      <input
                        type="text"
                        name="phone"
                        className="form-control bodytext"
                        placeholder="Phone"
                        onChange={this.onPhoneChange}
                        value={this.formatPhoneNumber(this.state.phone)}
                        size="30"
                      />
                    </div>
                    <div className="mt-1"> 
                      <input
                        type="text"
                        name="address"
                        className="form-control bodytext"
                        placeholder="Street address"
                        onChange={this.onAddressChange}
                        value={this.state.address}
                        size="30"
                      />
                    </div>
                    <div className="row mt-1 g-0">
                    <div className="col"> 
                      <input
                        type="text"
                        name="city"
                        className="form-control bodytext"
                        placeholder="City"
                        onChange={event => this.setState({ city: event.target.value })}
                        value={this.state.city}
                        size="30"
                      />
                    </div>
                    <div className="col ms-1"> 
                      <input
                        type="text"
                        name="state"
                        className="form-control bodytext"
                        placeholder="State/Province"
                        onChange={event => this.setState({ state: event.target.value })}
                        value={this.state.state}
                        size="30"
                      />
                    </div>
                    </div>
                    <div className="mt-1"> 
                      <input
                        type="text"
                        name="zip"
                        className="form-control bodytext"
                        placeholder="Zip/Postal Code"
                        onChange={this.onZipChange}
                        value={this.state.zip}
                        size="30"
                      />
                    </div>
                    { this.state.dBuyStarted && this.state.dBuyNeedsFinal && (
                        <div className="synchoverlay" >
                          <div className="synchoverlay-card" role="dialog" aria-modal="true">
                            <div className="synchspinnertext" >Finalizing Synchrony Transaction, please do not leave this page<div className="cfpspinner"></div></div>
                          </div>
                        </div>
                      ) 
                    }
                    { this.state.dBuyStarted && this.state.dBuyClosed && !this.state.dBuyNeedsFinal && (
                        <div className="synchoverlay" >
                          <div className="synchoverlay-card" role="dialog" aria-modal="true">
                            <div className="synchspinnertext" >Checking information, please do not leave this page<div className="cfpspinner"></div></div>
                          </div>
                        </div>
                      ) 
                    }
                    <br/><br/>
                    { this.state.authOnly ? (<h3>AUTH ONLY</h3>) : '' }
                    { !this.state.showCC && !this.state.authOnly ? (
                      <div>
                        <button type="button"
                          onClick={this.handleShowCC}
                          className="btnwide btn btn-primary"
                          style={{
                            backgroundColor: this.state.hexColorCode,
                            border: "none",
                            transition: "background-color 0.3s ease",
                          }}
                          onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                          onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}
                        >{ 'Pay with Card'}</button>
                      </div>
                    ) : <div/>}
                    { this.state.showCC && !this.state.payWithACH && !this.state.disableCC ? (
                      <div>
                        <div>
                          <div className="mt-1">
                              <div id="ccnumber"/>
                          </div>
                          <div className="row mt-1 g-0">
                            <div className="col">
                              <div id="ccexp"/>
                            </div>
                            <div className="col ms-1">
                              <div id="cvv"/>
                            </div>
                          </div>
                        </div>
                        <br/>
                      </div>
                    ) : <div/> }
                      
                    { this.state.achEnabled && this.state.payWithACH ? (
                      <div>
                      Enter Bank Information
                      <div>
                        <div className="mt-1">
                          <div id="checkaccount"/>
                        </div>
                        <div className="mt-1">
                          <div id="checkaba"/>
                        </div>
                        <div className="mt-1">
                          <div id="checkname"/>
                        </div>
                      </div>
                      </div>
                      ) : <div/>
                      }
                    
                    { this.state.achEnabled && !this.state.disableCC && !this.state.authOnly ? (
                      <div className="mt-1">
                        <div>
                          <button type="button"
                            onClick={this.toggleACH}
                            className="btnwide btn btn-primary mt-1 mb-1"
                            style={{
                              backgroundColor: this.state.hexColorCode,
                              border: "none",
                              transition: "background-color 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}
                          >{ this.state.payWithACH ? ( 'Click To Use Credit Card' ) : 'Click To Use Bank Account'}</button>
                        </div>
                      </div>
                    ) : <div/>}
                  </fieldset>
                  
                  {!this.state.hideSignature && (this.state.showCaptchaSignature && !this.state.disableCC && this.state.signatureHidden && !this.state.capture_signature ? ( 
                    <div className="mt-1"> 
                    <input type="text" name="fakenameremembered" style={{ display: 'none' }} />
                      <input
                        type="text"
                        name="no_autofill_123456"
                        autoComplete="new-signature"
                        className="form-control"
                        placeholder="Signature"
                        onClick={this.toggleSignature}
                      />
                    </div>
                  ) : this.state.showCaptchaSignature &&  this.state.signatureHidden && this.state.capture_signature ? (
                    <div className="form-control mt-1" onClick={this.toggleSignature}>
                      <img src={this.state.capture_signature} alt="image" className="img-fluid"/>
                    </div>
                  ) : this.state.showCaptchaSignature ? (
                    <div>
                      <div className="mt-1 form-control">
                        <SignaturePad key={this.state.sigPadKey} ref={this.signaturePadRef}/>
                      </div>
                      <div className="mt-1 mb-1">
                        <button type="button" onClick={this.handleClear} className="btn btn-light">Clear</button>
                      </div>
                    </div> 
                  ) : <div/> )}
                  
                    
                  { this.state.showCaptchaSignature ? (
                  <div className="mt-1 justify-content-center">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey="6LeajoYgAAAAAAipHXxCDX8k3zOIo8tJ4IDd-MQ6"
                      onChange={this.onChange}
                    />  
                  </div>
                  ) : <div/>}
                  { !this.state.hideAuxillaryPayments && this.state.payWithACH ? (
                      <button
                        type="submit"
                        className="btnwide btn btn-primary mt-1 mb-1"
                        disabled={this.state.isSubmitting || this.state.submitDisabled}
                        style={{
                          backgroundColor: this.state.hexColorCode,
                          border: "none",
                          transition: "background-color 0.3s ease",
                        }}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}
                      >Pay With ACH</button>
                    ) : 
                    <div/>
                  } 

                  { this.state.showCC && !this.state.payWithACH && !this.state.disableCC ? (
                    <button
                      type="submit"
                      className="btnwide btn btn-primary mt-1 mb-1"
                      disabled={this.state.isSubmitting || this.state.submitDisabled || this.state.disableCC}
                      style={{
                        backgroundColor: this.state.hexColorCode,
                        border: "none",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                      onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}
                    >{ this.state.authOnly ? ( 'Authorize With Card' ) : 'Pay With Card'}</button>
                    ) : 
                    <div/>
                  } 

                  


                  { !this.state.hideAuxillaryPayments && this.state.hasGooglePay && (
                    <div className="mb-1">
                      <div id="googlepaybutton"></div>
                    </div>
                  )}
                  {  !this.state.hideAuxillaryPayments && this.state.hasApplePay && window.ApplePaySession && (
                    <div className="mb-1">
                      <div id="applepaybutton"></div>
                    </div>
                  )}

                { (this.state.hasPayPal || this.state.hasVenmo)  && !this.state.hideAuxillaryPayments && this.state.payPalMerchantStatus && this.state.payPalMerchantStatus==='MERCHANT_ACTIVATED' && !this.state.authOnly && (
                  <div>
                    <hr style={{ height: '10px', visibility: 'hidden' }} />
                    <PayPal props={this.state} finishPayPal={this.finishPayPal} 
                      payPalId={this.state.payPalId} service={this.state.payPalService} platformfee={this.state.payPalPlatformFee} 
                      hidePayLater={this.state.Hide_Paypal_Pay_Later}/> 
                  
                  </div>
                )}

                { this.state.lendResultLoading && (
                  <div className="cfpspinnertext" >Loading Lend Results ... <div className="cfpspinner"></div></div>
                )}

                { !this.state.lendResultLoading &&  this.state.lendApplyUrl && !this.state.isSynchrony && (
                  <div className="box" style={{ borderLeft: `5px solid ${this.state.hexColorCode}` }}>
                    <b>
                      <h6>
                        {this.state.lendResult && (<div style={{ color: 'white' }} dangerouslySetInnerHTML={{ __html: this.state.lendResult }} />)}
                        {this.state.lendApplyUrl && (<div className="mt-2" style={{ color: 'white' }}>
                          <a 
                            target="_blank"
                            href={this.state.lendApplyUrl}
                            className="btn btn-primary btn-sm"
                            style={{
                              backgroundColor: this.state.hexColorCode,
                              border: "none",
                              transition: "background-color 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}>
                            <b>Apply Now</b>
                          </a>
                        </div>)}
                      </h6>  
                    </b>
                  </div>   
                )}

                { !this.state.reloadSynchrony && !this.state.lendResultLoading && this.state.lendResult && this.state.isSynchrony &&  (
                  <div className="inline">
                    <SynchDbuy key={this.state.synchkey} address={this.state.address} zip={this.state.zip} dBuyStarted={this.dBuyStarted} dBuyFinished={this.dBuyFinished} props={this.state} />
                  </div>  
                )}   
              </form>
            )}

            { this.state.isInternal && this.state.hasFleet && (
              <button
                className="btnwide btn btn-primary mt-1 mb-1"
                disabled={this.state.isSubmitting || this.state.payWithWex}
                style={{
                  backgroundColor: this.state.hexColorCode,
                  border: "none",
                  transition: "background-color 0.3s ease",
                }}
                onClick={this.handleWex}
                onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}
              >Pay With Wex</button>
              )
            } 
            { this.state.isInternal && this.state.hasFleet && (
              <button
                className="btnwide btn btn-primary mt-1 mb-1"
                disabled={this.state.isSubmitting || this.state.payWithVoyager }
                style={{
                  backgroundColor: this.state.hexColorCode,
                  border: "none",
                  transition: "background-color 0.3s ease",
                }}
                onClick={this.handleVoyager}
                onMouseEnter={(e) => (e.target.style.backgroundColor = this.state.hoverColor)}
                onMouseLeave={(e) => (e.target.style.backgroundColor = this.state.hexColorCode)}
              >Pay With Voyager</button>
              )
            }

            { ( this.state.payWithWex || this.state.payWithVoyager) && (
              <div className="row justify-content-center">
                 {this.state.fleetediting ? (
                    <FleetItems
                      onSave={this.handleSaveFleetItems}
                      initialItems={this.state.fleetitems}
                    />
                  ) : (
                    <div>
                      <h3 style={{  'font-size': '20px', color: this.state.hexColorCode || '#36454F' }}>Saved Items Total ${this.state.fleettotal.toFixed(2)}</h3>
                      
                      {this.state.fleetitems.length > 0 ? (
                        <>
                          <table
                            className="" 
                            border="1"
                            cellPadding="6"
                            style={{ "border-radius": "0.25rem", width: "100%", borderCollapse: "collapse" }}
                          >
                            <thead>
                              <tr>
                                <th>Product / Description</th>
                                {/* <th>Description</th> */} 
                                <th>Qty</th>
                                <th>Price</th>
                                <th>Line Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.fleetitems.map((item, i) => (
                                <tr key={i}>
                                  <td>{item.productCode} - {item.description}</td>
                                  {/* <td>{item.description}</td> */}
                                  <td>{item.quantity}</td>
                                  <td>${item.price.toFixed(2)}</td>
                                  <td>${(item.quantity * item.price).toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <h3 style={{ marginTop: "10px" }}>
                            
                            { ( this.state.payWithWex || this.state.payWithVoyager ) && this.state.fleettotal.toFixed(2) !== this.state.amount && ( 
                              <div className="mt-1 g-0 row justify-content-center" style={{ 'font-size': '20px', color: 'red' }}><b>Item Total Must match Order Total of ${this.state.amount}</b></div> 
                            )}
                          </h3>
                        </>
                      ) : (
                        <p>No items saved.</p>
                      )}
                      <button
                        className="btn btn-primary mt-1 mb-2"
                        onClick={this.setIsEditing}
                        style={{ marginTop: "10px" }}
                      >
                        Add/Edit Items
                      </button>
                    </div>
                  )}
              </div>
            )}

            
            { (this.state.payWithWex || this.state.payWithVoyager) && this.state.fleetitems && this.state.fleetitems.length > 0 && this.state.fleettotal.toFixed(2) == this.state.amount && (
              <div>
                <Fleet props={this.state} onSuccess={this.fleetSuccess} onError={this.fleetError} onInvalid={this.fleetInvalid} />
                { this.state.fleetProcessing && (
                  <div className="synchoverlay" >
                    <div className="synchoverlay-card" role="dialog" aria-modal="true">
                      { this.state.payWithWex && (
                        <div className="synchspinnertext" >Finalizing WEX Payment, please do not leave this page <div className="cfpspinner"></div></div>
                      )
                      }
                      { this.state.payWithVoyager && (
                        <div className="synchspinnertext" >Finalizing Voyager Payment, please do not leave this page <div className="cfpspinner"></div></div>
                      )
                      }
                    </div>
                  </div>
                )}
              </div>
            )}

            {!this.state.isInternal && (
              <> <h4 className="mt-4 text-start" style={{ color: this.state.hexColorCode || '#36454F' }}><b>Additional Information</b></h4>
              {this.state.invoiceNotes && <div className="row justify-content-center mt-3">
                <div className="col text-start" style={{ 
                  border: "2px solid #7d7d7d", 
                  borderRadius: "5px",
                  padding: "6px", 
                  maxWidth: "96%",  
                  boxShadow: "0px 10px 10px -10px #353535",
                }}>
                  {<p><b>{this.state.invoiceNotesLabel || 'Notes'}</b><br/>
                    <i>{this.state.invoiceNotes}</i></p>}
                </div>
              </div>}
              {this.state.disclosure && <div className="row justify-content-center mt-3">
                <div className="col text-start" style={{ 
                  border: "2px solid #7d7d7d", 
                  borderRadius: "5px",
                  padding: "6px", 
                  maxWidth: "96%",  
                  boxShadow: "0px 10px 10px -10px #353535",
                }}>
                  {<p><b>Disclosure</b><br/><i>{this.state.disclosure}</i></p>}
                </div>
              </div>}
              <div className="row justify-content-center mt-3">
                <div className="col text-start" style={{ 
                  border: "2px solid #7d7d7d", 
                  borderRadius: "5px",
                  padding: "6px", 
                  maxWidth: "96%",  
                  boxShadow: "0px 10px 10px -10px #353535",
                }}>
                  {<p><b>Secure Payments</b><br/><i>All transactions are secure and encrypted. We never store your full credit card information.</i></p>}
                </div>
              </div>
              <hr style={{ width: "70%", margin: "20px auto", border: "1.2px solidhsl(0, 84.00%, 46.50%)" }} />
              {/* { !isInternal && !hideHeader && <h6><b>{this.state.accountName}</b></h6>} */}
              {/* { !isInternal && !hideHeader && <h6>{this.formatPhoneNumber(this.state.accountPhone)}</h6>} */}
            </>)}
          </div>
        </div>
      </div>
    )
  }
}

function PaymentReceipt(props) {
  const [captureEmail, setCaptureEmail] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [email, setEmail] = useState()
  const handleClick = () => {
    console.log('click')
    if (!captureEmail) {
      setCaptureEmail(true)
    } else if (captureEmail && email) {
      setIsSubmitting(true)
      html2canvas(document.getElementById('root')).then(function(canvas) {
        return props.handleEmail({ canvas: canvas.toDataURL(), email })
      })
    }
  }
  return (
    <div>
      <Receipt {...props} />
      <div className="col d-flex justify-content-center">
        <div className="row justify-content-center">
          { captureEmail && (
            <input
            type="email"
            name="email"
            className="form-control mt-1"
            placeholder="Email Address"
            onChange={event => setEmail(event.target.value)}
            data-html2canvas-ignore
            />
          )}
          <button
            type="submit"
            onClick={handleClick}
            className="btn btn-primary mt-1 mb-2"
            data-html2canvas-ignore
            disabled={isSubmitting}
            style={{
              backgroundColor: props.hexColorCode,
              border: "none",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = props.hoverColor)}
            onMouseLeave={(e) => (e.target.style.backgroundColor = props.hexColorCode)}
          >
            Email Receipt
          </button>
        </div>
      </div>
    </div>
  )
}

//import venmo from '../images/Venmo3.png'
//{ this.state.hasVenmo && (
//  <img style={{ width: 100 + '%', height: 65 + 'px' }} src={venmo} alt="image" className="img-fluid rounded mt-1"/>
//)}
//import paypal from '../images/PayPal2.png'
import PayPal from '../components/PayPal2.js'
import PayPalReceipt from './paypalreceipt.js'
import Fleet from './fleet.js'
import FleetItems from './fleetitems.js'

// import { signedPayment } from '../../../functions/onCall/index.js'

function PayPalPaymentReceipt(props) {
    const [captureEmail, setCaptureEmail] = useState(false)
    const [email, setEmail] = useState()
    const handleClick = () => {
      console.log('paypal receipt click')
      if (!captureEmail) {
        setCaptureEmail(true)
      } else if (captureEmail && email) {
        html2canvas(document.getElementById('root')).then(function(canvas) {
          props.handleEmail({ canvas: canvas.toDataURL(), email })
        })
      }
    }
    /* <PayPalReceipt amountPaid={propData.amount} authCode={authCode} /> */
    return (
      <div>
        <PayPalReceipt {...props}/>
        <div className="col d-flex justify-content-center">
          <div className="row justify-content-center">
            { captureEmail && (
              <input
              type="email"
              name="email"
              className="form-control mt-1"
              placeholder="Email Address"
              onChange={event => setEmail(event.target.value)}
              data-html2canvas-ignore
              />
            )}
            <button
              type="submit"
              onClick={handleClick}
              className="btn btn-primary mt-1 mb-2"
              data-html2canvas-ignore
              style={{
                backgroundColor: props.hexColorCode,
                border: "none",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = props.hoverColor)}
              onMouseLeave={(e) => (e.target.style.backgroundColor = props.hexColorCode)}
            >
              Email Receipt
            </button>
          </div>
        </div>
      </div>
    )
  }
